var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.57 71.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.07 69.93H1.5V1.5h38.33l11.24 11.1zM26.28 44.75V26.68m-9.03 9.04h18.07"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.28,
    cy: 35.72,
    r: 14.47
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNote);
export default __webpack_public_path__ + "static/media/addNote.053031201153767cd63ed40ed686f3a3.svg";
export { ForwardRef as ReactComponent };